module.exports = __webpack_public_path__ + "img/9788952217448.c5134fb8.jpg";